import { useNavigate } from "react-router-dom";
import { IESignRule } from "../../../../models/esign-rule";
import MainApi from "../../../../services/mainApi.service";
import { useTranslation } from "react-i18next";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { Chip } from "@mui/material";

const translationPath = "4uESign.page.automations.automationRules.";

const _4UESIGN_AUTOMATION_RULE_ROUTE =
  process.env.REACT_APP_4UESIGN + "/api/v1/ESignRule/";
const esignRulesService = new MainApi<IESignRule>(
  _4UESIGN_AUTOMATION_RULE_ROUTE,
);

const AutomationRulePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns: GridColDef<IESignRule>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "code",
      headerName: t(translationPath + "code") || "Code",
      maxWidth: 120,
    },
    {
      field: "priority",
      headerName: t(translationPath + "priority") || "Priority",
      maxWidth: 120,
    },
    {
      field: "esignAutomation",
      headerName: t(translationPath + "automation") || "Automation",
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value.name}
            tooltip={params.value.name}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "createdByUserName",
      headerName: t(translationPath + "created_by") || "Created By",
      maxWidth: 300,
      renderCell: (params) =>
        params.value ? (
          <OverflowTooltip
            text={params.value}
            tooltip={params.value}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        ),
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 120,
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationPath + "active")
              : t(translationPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IESignRule>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IESignRule>
      showDefaultMacroFilters={false}
      service={esignRulesService}
      columns={columns}
      title={t(translationPath + "automation_rules")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      // lib4uhub: shouldShowDeleteButtonForRow é invertido - retornar true ESCONDE o botão de excluir.
      // Regra ativa (enable=true) => sem excluir; regra inativa (enable=false) => com excluir.
      shouldShowDeleteButtonForRow={(params) => params.row.enable}
      defaultPageSize={20}
      pageSizeOptions={[5, 10, 20]}
      searchInputPlaceHolder={t(translationPath + "search")}
      addButtonLabel={
        t(translationPath + "add_automation_rule") || "Add Automation Rule"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default AutomationRulePage;
